import type { ITopWin } from '../types/topWins.types';

/**
 * The canonical Top Wins list: the featured win first (de-duplicated by id),
 * then the recent wins. Shared so the single-view section, its header count and
 * the multi-view "All (N)" link all agree on the same set/size.
 */
export const buildTopWinsList = (featured: ITopWin | null, recent: ITopWin[]): ITopWin[] => {
  const list: ITopWin[] = [];
  const seen = new Set<string>();
  const push = (win: ITopWin | null | undefined) => {
    if (!win || seen.has(win.id)) return;
    seen.add(win.id);
    list.push(win);
  };
  push(featured);
  recent.forEach(push);
  return list;
};
